import { useQuery } from "@tanstack/react-query";
import { qk } from "#/lib/queryKeys";
import useAdminTemplatesApi from "#/admin/templates/hooks/useAdminTemplatesApi";

export function useAdminTemplateDetail(id: string | undefined) {
  const api = useAdminTemplatesApi();

  return useQuery({
    queryKey: id ? qk.messageTemplateDetail(id) : ["message-templates", "detail"],
    queryFn: ({ signal }) => {
      if (!id) {
        return Promise.reject(new Error("Template id is required"));
      }
      return api.getTemplate(id, { signal });
    },
    enabled: Boolean(id),
    staleTime: 30_000,
  });
}

export default useAdminTemplateDetail;
